import React from 'react';
const DescriptionsContext = React.createContext({});
export default DescriptionsContext;
